import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';

import { LoginService } from '@services/login.service';
import { AuthService } from '@services/auth.service';
import { CommonMethods } from '@services/common.method';
import { NotificationsService } from '@shared/services/notification';
import { AppInfoModel } from '@models/app-info.model';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { Constants } from 'src/app/shared/models/constants';
import { LoaderType } from 'src/app/shared/enums/common';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [LoginService]
})
export class LoginComponent implements OnInit {

  //#region Variable Declarations
  public loginForm: FormGroup;
  public appInfoDS: AppInfoModel;
  //#endregion

  //#region Constructor
  constructor(
    private frmbuilder: FormBuilder,
    private toastr: NotificationsService,
    private commonMethod: CommonMethods,
    private loginService: LoginService,
    private router: Router,   
    private auth: AuthService,
    private showspinner: SpinnerService,
      private viewContainerRef: ViewContainerRef) {
      this.appInfoDS = new AppInfoModel();
    this.CreateForm();
  }
  //#endregion

  //#region Lifecycle Events
  ngOnInit() {
    this.loginService.Hello().subscribe(r => {
      this.auth.setAppInfo(r);
      this.appInfoDS = this.auth.getAppInfo();
    });
  }
  //#endregion

  //#region Methods
  private CreateForm() {
    this.loginForm = this.frmbuilder.group({
      "Username": new FormControl("", [this.loginService.noWhitespaceValidator]),
      "Password": new FormControl("", [this.loginService.noWhitespaceValidator])
    });
  }

  public OnSubmit() {
    if (this.loginForm.valid) {
      this.showspinner.showloader(this.viewContainerRef, Constants.FixedtabCounters.loginComponent, 0, false, 0, LoaderType.circle);
      this.loginService.Login(this.loginForm.value).subscribe(response => {
        this.auth.setToken(response.Token);
        this.auth.setUserName(response.FirstName + " " + response.LastName);
        this.auth.setCompanyId(response.Company.ID);
        let companyInfo = response.Company.CompanyInfo;
        if (CommonMethods.CheckNullOrUndefined(companyInfo) || CommonMethods.CheckNullOrUndefined(companyInfo.AccountingIntegrationType))
          this.auth.setCompanyQBType("None");
        else
          this.auth.setCompanyQBType(companyInfo.AccountingIntegrationType.Code);

        this.auth.setUserId(response.ID);
        if (response.Unauthorized.length > 0) {
          let unAuthorizedList = "|";
          response.Unauthorized.forEach(element => {
            unAuthorizedList = unAuthorizedList + element.AccessibleElement.toLowerCase() + "|"
          });
          this.auth.setUnAuthorizedList(unAuthorizedList);
        }
        let timezoneInfo = JSON.stringify(response.TimeZoneDSTList.find(x => x.Year == new Date().getFullYear()));

        this.auth.setUserTimeZone(timezoneInfo);
        this.auth.setUserPlan('l');
        this.auth.setCreditPaymentAllowed(response.IsCreditCardPaymentEnabled);
        this.router.navigate(['/home']);
        this.showspinner.hideLoader(this.viewContainerRef, Constants.FixedtabCounters.loginComponent);
      },
        error => {
          this.showspinner.hideLoader(this.viewContainerRef, Constants.FixedtabCounters.loginComponent);
          //show toaster is visible on interceptor file
          //this.commonMethod.isNullOrUndefined(error.error) ? "Something went wrong" : this.toastr.showMultiLineError(error.error.Message);
        })
    }
    else {
      this.loginService.markFormGroupTouched(this.loginForm)
    }
  }
  //#endregion
}
